module.exports = __webpack_public_path__ + "media/images/gravatar-a745c584d3266e593e60f34798a6f529.png";